import { render, staticRenderFns } from "./businessIntelligence.vue?vue&type=template&id=831717fc&"
import script from "./businessIntelligence.vue?vue&type=script&lang=js&"
export * from "./businessIntelligence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('831717fc')) {
      api.createRecord('831717fc', component.options)
    } else {
      api.reload('831717fc', component.options)
    }
    module.hot.accept("./businessIntelligence.vue?vue&type=template&id=831717fc&", function () {
      api.rerender('831717fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/businessIntelligence.vue"
export default component.exports